let _Single = null;
export default function() {
    return class toolInstance {
        constructor() {
            if (!_Single) {
                _Single = this;
            }
            return _Single;
        }

        static single() {
            if (!_Single) _Single = new toolInstance();
            return _Single;
        }

        /*大于壹钱包App版本 4.4.0 return true---start---*/
        compareVersion(version,baseVersion) {
            let versionNumArray = version.split('.');
            let baseVersionNumArray = baseVersion.split('.');
            let versionNum = parseInt(versionNumArray[0] + versionNumArray[1] +(versionNumArray[2]||"0")+(versionNumArray[3]||"0"));
            let baseVertion = parseInt(baseVersionNumArray[0] + baseVersionNumArray[1] +(baseVersionNumArray[2]||"0")+(baseVersionNumArray[3]||"0"));
            if (versionNum >= baseVertion){
                return true
            } else {

                return false;
            }
        }
        getIOSVersion() {
            let ua = navigator.userAgent;
            if (ua.toLowerCase().indexOf("like mac os x") > 0) {
                let regStr_saf = /os [\d._]*/gi;
                let verinfo = ua.toLowerCase().match(regStr_saf);
                return (verinfo + "").replace(/[^0-9|_.]/ig, "").replace(/_/ig, ".");
            }
            return false
        }

        /*判断当前所在场景环境*/
        isBrowserClient(){
            var ua = navigator.userAgent.toLowerCase();
            if (/micromessenger/i.test(ua)) {
                return 'wechat';
            } else if (/1qianbao/i.test(ua)) {
                return 'YQB';
            }else if (/mqqbrowser/i.test(ua)) {
                return 'qq';
            }  else if (/weibo/i.test(ua)) {
                return 'weibo';
            } else {
                return 'h5';
            }
        }

        isOSClient() {
            var ua = navigator.userAgent.toLowerCase();
            if (/android/i.test(ua)) {
                return 'android';
            } else if (/ipad|ipod|iphone/i.test(ua)) {
                return 'ios';
            } else {
                return 'others';
            }
        }

        riskClient() {
            var ua = navigator.userAgent.toLowerCase();

            if (/micromessenger/i.test(ua)) {
                return 'wechat';
            } else if (/1qianbao/i.test(ua)) {
                return 'M-100001';
            } else if (/android/i.test(ua)) {
                return 'android';
            } else if (/ucbrowser/i.test(ua)) {
                return 'uc';
            }  else if (/mqqbrowser/i.test(ua)) {
                return 'qq';
            }  else if (/weibo/i.test(ua)) {
                return 'weibo';
            }  else if (/firefox/i.test(ua)) {
                return 'FF';
            }  else if (/chrome/i.test(ua)) {
                return 'chrome';
            }  else if (/msie/i.test(ua)) {
                return 'IE';
            }    else if (/safari/i.test(ua)) {
                return 'safari';
            }  else if (/MetaSr/i.test(ua)) {
                return 'sogo';
            }   else {
                return 'h5';
            }
        }

        Base64Encode(str, needUtf16to8) {
            var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            //中文uft-16 转化为 utf-8
            function utf16to8(str) {
                var out = "",
                    i,
                    len = str.length,
                    c;
                for (i = 0; i < len; i++) {
                    c = str.charCodeAt(i);
                    if ((c >= 0x0001) && (c <= 0x007F)) {
                        out += str.charAt(i);
                    } else if (c > 0x07FF) {
                        out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                        out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                    } else {
                        out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                    }
                }
                return out;
            }
            //base64编码
            function encode64(input) {
                var output = "";
                var chr1, chr2, chr3 = "";
                var enc1, enc2, enc3, enc4 = "";
                var i = 0;
                do {
                    chr1 = input.charCodeAt(i++);
                    chr2 = input.charCodeAt(i++);
                    chr3 = input.charCodeAt(i++);
                    enc1 = chr1 >> 2;
                    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                    enc4 = chr3 & 63;
                    if (isNaN(chr2)) {
                        enc3 = enc4 = 64;
                    } else if (isNaN(chr3)) {
                        enc4 = 64;
                    }
                    output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
                    chr1 = chr2 = chr3 = "";
                    enc1 = enc2 = enc3 = enc4 = "";
                } while (i < input.length);
                return output;
            }

            if (needUtf16to8) {
                return encode64(utf16to8(str));
            } else {
                return encode64(str);
            }
        }

        getStateParams() {
            var pairs = window.location.search.substring(1).split("&"),
                obj = {},
                pair, i;
            if (window.location.search !== "") {
                for (i in pairs) {
                    if (pairs[i] === "") continue;
                    pair = pairs[i].split("=");
                    obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
                }
            }
            return obj;
        }
        
        getUrlParam(name, url){
            if(!name){
                return '';
            }
            url = url || location.search;
            name = name.replace(/(?=[\\^$*+?.():|{}])/, '\\');
            var reg = new RegExp('(?:[?&]|^)' + name + '=([^?&#]*)', 'i');
            var match = url.match(reg);
            return !match ? '' : match[1];
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/tools.js